import script from "./500InternalServerError.vue?vue&type=script&setup=true&lang=js"
export * from "./500InternalServerError.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__